// Hook para manejar los pedidos enviados por clientes hijos (tenant_3pl)
// Hook for managing child team orders (tenant_3pl)

import { useQuery } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { ChildTeamOrdersApiAdapter, ChildTeamOrdersData } from '../adapters/ChildTeamOrdersApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';

export const useChildTeamOrders = () => {
  const { toast } = useToast();
  const childTeamOrdersAdapter = new ChildTeamOrdersApiAdapter(apiClientWH);

  const {
    data: childTeamOrdersResponse,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['childTeamOrders'],
    queryFn: () => childTeamOrdersAdapter.getOrdersSentByChildTeam(),
    staleTime: 5 * 60 * 1000, // 5 minutos de cache
    gcTime: 10 * 60 * 1000, // 10 minutos
    retry: 2,
    onError: (error: any) => {
      // Solo mostrar toast si es un error inesperado (no 403)
      if (error?.response?.status !== 403) {
        toast({
          title: 'Error al cargar datos de clientes',
          description: error?.message || 'Error inesperado. Inténtalo de nuevo.',
          variant: 'destructive',
        });
      }
    },
  });

  // 🎯 Datos por defecto si no hay respuesta
  const defaultData: ChildTeamOrdersData = {
    parent_team_id: 0,
    date: new Date().toISOString().split('T')[0],
    child_teams: [],
  };

  return {
    childTeamOrders: childTeamOrdersResponse?.data || defaultData,
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};

